"use client";

import React from "react";
import { Button, LoadingSpinner } from "@wtc/ui";
import { Download, ExternalLink, AlertTriangle } from "lucide-react";

interface UnavailablePreviewProps {
  title: string;
  description: string;
  /** Pass a warning icon (e.g. AlertTriangle) instead of the file-type icon. */
  warningStyle?: boolean;
  fileTypeIcon?: React.ReactNode;
  canDownload: boolean;
  isDownloading?: boolean;
  onOpenInDrive: () => void;
  onDownload?: () => void;
  /** Show only the Open-in-Drive button (no download). */
  openInDriveOnly?: boolean;
}

export function UnavailablePreview({
  title,
  description,
  warningStyle = false,
  fileTypeIcon,
  canDownload,
  isDownloading = false,
  onOpenInDrive,
  onDownload,
  openInDriveOnly = false,
}: UnavailablePreviewProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      {warningStyle ? (
        <AlertTriangle className="h-12 w-12 text-yellow-500 mb-4" />
      ) : (
        fileTypeIcon
      )}
      <h3 className={warningStyle ? "text-lg font-semibold mb-2" : "text-lg font-semibold mt-4 mb-2"}>
        {title}
      </h3>
      <p className="text-muted-foreground mb-4">{description}</p>
      {openInDriveOnly ? (
        <Button onClick={onOpenInDrive} variant="outline">
          <ExternalLink className="h-4 w-4 mr-2" />
          Open in Google Drive
        </Button>
      ) : (
        <div className="flex gap-2">
          <Button onClick={onOpenInDrive} variant="outline">
            <ExternalLink className="h-4 w-4 mr-2" />
            Open in Drive
          </Button>
          {canDownload && onDownload && (
            <Button onClick={onDownload} disabled={isDownloading}>
              {isDownloading ? (
                <LoadingSpinner className="h-4 w-4 mr-2" />
              ) : (
                <Download className="h-4 w-4 mr-2" />
              )}
              Download
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
